import MenuNames from "../../../constants/Menu/MenuNames.json";
import RiderOffers from "../../../views/RiderOffers";

const RiderOffersRoutes = [
  {
    menuName: MenuNames.RIDER_PAYOUT_HISTORY,
    path: "/rider-offers",
    component: RiderOffers,
    exact: true,
  },
];

export default RiderOffersRoutes;
